<script setup lang="ts">
	import {useFavoriteProductStore} from '@/store/favorite.product.store';
	import {storeToRefs} from 'pinia';
	import {useAppStore} from '@/store/app.store';
	import ConfirmClearFavoritesModal from '@/components/favorites/ConfirmClearFavoritesModal.vue';
	import {useI18n} from 'vue-i18n';

	const emit = defineEmits(['favorites-cleared']);

	const favoriteStore = useFavoriteProductStore();
	const {favoriteAmount} = storeToRefs(favoriteStore);

	const {t} = useI18n();

	const clearFavorites = () => useAppStore().confirmClearFavoritesModalActive = true;
</script>

<template>
	<button :class="[favoriteAmount === 0 ? 'disabled' : '']"
	        :disabled="favoriteAmount === 0"
	        class="catalog-overview-header__favorites ml-0"
	        type="button"
	        :aria-label="t('site.products.overview.favorites.clear.tooltip')"
	        @click="clearFavorites">

		<svg width="20" height="19" class="icon-delete-star">
			<use xlink:href="/assets/images/build/svg-sprite.catalog.min.svg#delete-star"></use>
		</svg>
	</button>

	<ConfirmClearFavoritesModal @favorites-cleared="emit('favorites-cleared')" />
</template>
